import styled, { css } from 'styled-components';

export const ModalContent = styled.div`
  display: grid;
  row-gap: 1rem;
  text-align: center;
  ${(props) =>
    props.maxWidth &&
    css`
      max-width: ${props.maxWidth};
    `}
`;

export const AvatarWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const StartButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 24px;
`;
